import React, { useEffect, useState } from 'react';
import { AlertTriangle, Clock, FileText, FlaskConical, Leaf } from 'lucide-react';
import { Section } from './Shared';
import { FeatherQuill, MoonPhase } from './HealingIcons';
import { Pricing } from './Pricing';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 22,
    m: 37,
    s: 44
  });
  const [spotsTaken] = useState(94);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-243" data-mp="1wu7fd2o9z16w">
      <div className="bg-brand-purple text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-purpleLight/40" data-id="element-244" data-mp="1wkoyz2gftnq8">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-sm font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-245" data-mp="25jsl6fawij8y">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-246" data-mp="2fi8cai9xhsig">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-purple/40 bg-gradient-to-br from-white/95 to-brand-purpleLight/10 shadow-[0_10px_40px_rgba(45,95,63,0.12)]" data-id="element-247" data-mp="2fh6xc2psklvg">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-248" data-mp="2p9w6us1s7po5">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-purple shrink-0" data-id="element-249" data-mp="2t9ei0w3swmds" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-purpleDark text-center" data-id="element-250" data-mp="2yakbwx976fow">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-251" data-mp="136cvwpl87ww7">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-252" data-mp="1349ul9emihc6" />
          <span className="text-2xl md:text-4xl font-bold text-brand-purple/60 pb-5" data-id="element-253" data-mp="y8kwlai958hz">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-254" data-mp="1cy0gc6jd8do6" />
          <span className="text-2xl md:text-4xl font-bold text-brand-purple/60 pb-5" data-id="element-255" data-mp="1857crlzmvbdo">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-256" data-mp="1lwcdysingbq4" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-257" data-mp="1hvis04orp6zv">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-amber-600 shrink-0" data-id="element-258" data-mp="1vvjutpoleohz" />
          <p className="text-sm md:text-base font-semibold text-amber-900 text-center" data-id="element-259" data-mp="1qvp3xm4thywx">
            Después sube a $35.000 ARS.{' '}
            <span className="text-brand-purple" data-id="element-260" data-mp="1i25py8jhjku">No vuelve.</span>
          </p>
        </div>

        <div className="bg-white/80 rounded-2xl p-4 md:p-5 border border-brand-purple/30" data-id="element-261" data-mp="3sovebn5nwkze">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-262" data-mp="286klf2ud7gki">
            <div className="flex items-center gap-2" data-id="element-263" data-mp="2d3kr3cnayhb3">
              <span className="relative flex h-2.5 w-2.5" data-id="element-264" data-mp="1yfpxlu1h08wy">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-burgundy opacity-75" data-id="element-265" data-mp="1yf6pt65jb0wn"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-burgundy" data-id="element-266" data-mp="23cgdohd9z4id"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-267" data-mp="1uenuv38cheq8">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-purple uppercase tracking-wide" data-id="element-268" data-mp="1fj88lke0an4e">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-purple/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-269" data-mp="39w6g5w8bn5o1">
            <div className="bg-gradient-to-r from-brand-purple to-brand-purpleDark h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-270" data-mp="3esoiyqk3ctxq" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-271" data-mp="15qs7yi8c9nm9">
            <strong className="text-brand-purple" data-id="element-272" data-mp="15sv5rofqgl1j">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const tomo1Features = ['✅ Nombre científico y popular', '✅ Principios activos y acción farmacológica', '✅ Indicaciones terapéuticas por nivel de evidencia', '✅ Dosificación profesional por preparación', '✅ Contraindicaciones y poblaciones de riesgo', '✅ Semáforo de seguridad 🟢🟡🔴', '✅ Referencias científicas verificables'];
const tomo2Features = ['✅ Fundamentos de extracción vegetal', '✅ Selección de solventes según principio activo', '✅ Infusiones y decocciones con temperaturas exactas', '✅ Tinturas madre y alcoholaturas paso a paso', '✅ Oleatos en frío y en caliente', '✅ Pomadas, ungüentos y cremas', '✅ Jarabes, elixires y arropes medicinales', '✅ Control de calidad artesanal', '✅ Conservación, envasado y vida útil', '✅ Buenas Prácticas de Elaboración (BPE)', '✅ Etiquetado profesional obligatorio'];
const tomo3Features = ['✅ Tabla maestra de interacciones planta-fármaco', '✅ Dosificación en embarazo y lactancia', '✅ Protocolo ante reacciones adversas', '✅ Señales de alarma clínica', '✅ Checklist del terapeuta antes de prescribir'];
const protocolos = [{
  sys: '🌿 Digestivo',
  cond: 'Gastritis, SII, Hepatitis crónica'
}, {
  sys: '🫁 Respiratorio',
  cond: 'Resfrío, Gripe, Asma, Bronquitis'
}, {
  sys: '🧠 Nervioso',
  cond: 'Ansiedad, Insomnio, Depresión leve'
}, {
  sys: '❤️ Cardiovascular',
  cond: 'Hipertensión, Várices, Colesterol'
}, {
  sys: '⚖️ Endocrino',
  cond: 'Diabetes tipo 2, Menopausia, Tiroides'
}, {
  sys: '🦴 Osteoarticular',
  cond: 'Artritis, Artrosis, Osteoporosis'
}];
const bonuses = [{
  icon: FileText,
  title: 'FICHAS DE CONSULTORIO: GESTIÓN DE PACIENTES',
  pages: '30 páginas · listo para imprimir',
  color: 'text-brand-purple',
  bgColor: 'bg-brand-purple/10',
  borderColor: 'border-brand-purple/30',
  desc: 'Sistema completo de registro clínico para terapeutas de salud natural. Desde la primera consulta hasta el alta terapéutica.',
  result: '✅ Registro clínico profesional desde el primer paciente',
  price: '$12.000'
}, {
  icon: FlaskConical,
  title: 'RECETARIO MAESTRO: 48 FÓRMULAS MAGISTRALES',
  pages: '45 páginas · listo para imprimir',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  desc: '48 fórmulas concretas y listas para usar organizadas por objetivo terapéutico. Infusiones, extractos y pomadas.',
  result: '✅ Respuesta concreta para cada cuadro',
  price: '$15.000'
}, {
  icon: Leaf,
  title: 'GUÍA DE PROVEEDORES Y COSECHA ÉTICA',
  pages: '30 páginas · listo para imprimir',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-goldLight/10',
  borderColor: 'border-brand-goldLight/40',
  desc: 'Todo lo que necesitás saber para conseguir materia prima de calidad, evaluarla correctamente y cosechar con conciencia terapéutica.',
  result: '✅ Materia prima de calidad asegurada',
  price: '$10.000'
}];
const tomo4Features = ['✅ Fundamentos de espagiria vegetal argentina', '✅ El trinomio alquímico aplicado a plantas nativas', '✅ Técnica maestra del elixir espagírico', '✅ Fitococina terapéutica argentina', '✅ Recetario alquímico con preparaciones exclusivas', '✅ Elixires con triple extracción para mayor potencia', '✅ Preparaciones especiales para pacientes que no toleran alcohol', '✅ Semáforo de seguridad para preparaciones avanzadas'];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-273" data-mp="g4tzfbicwz0l">
      {/* Decorative elements */}
      <FeatherQuill className="hidden lg:block absolute top-20 right-[3%] w-8 h-8 opacity-25 animate-float-soft" color="#2D5F3F" style={{
      transform: 'rotate(-15deg)'
    }} data-id="element-274" data-mp="bedjnkr2d1b2" />
      <MoonPhase className="hidden lg:block absolute top-60 left-[2%] w-10 h-10 opacity-30 animate-float-soft" color="#6B9A7A" style={{
      transform: 'rotate(12deg)',
      animationDelay: '1.5s'
    }} data-id="element-275" data-mp="1gpoitpjprsd" />

      <div className="text-center mb-12" data-id="element-276" data-mp="u5msdrt0fm1l">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-purple/40 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-277" data-mp="p5iem9jhl5f2">
          <span className="text-xl" data-id="element-278" data-mp="k65ptj921o9u">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-purple text-sm md:text-base" data-id="element-279" data-mp="39vzmpqqbecuv">
            KIT SABERES ANCESTRALES ARGENTINOS™
          </span>
        </div>
        <h2 className="text-2xl md:text-5xl font-display font-bold mb-4 leading-tight text-brand-purpleDark" data-id="element-280" data-mp="34z97f5mc3lai">
          4 Tomos Principales + 3 Bonus Estratégicos
        </h2>
        <p className="text-brand-text/70 text-base md:text-lg" data-id="element-281" data-mp="1pe8a6ip0rorw">
          385 páginas — Todo resuelto.
        </p>
      </div>

      <div className="max-w-5xl mx-auto mb-12 space-y-6" data-id="element-282" data-mp="1ub8jr3l2v9nr">
        {/* Tomo I */}
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-purpleDark/15 border-brand-purpleDark/30 backdrop-blur-sm shadow-sm" data-id="element-283" data-mp="1z5utl2bigu5q">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-284" data-mp="2846huxownfv0">
            <div className="shrink-0 mx-auto md:mx-0 w-24 md:w-28" data-id="element-285" data-mp="2d3jega5kw1as">
              <img src="https://cdn.magicpatterns.com/uploads/r5x75ZwsaMMfLUoonNog6G/tomo_1.png" alt="Tomo I — Enciclopedia A-Z" className="w-full aspect-[3/4] object-cover rounded-md shadow-lg ring-1 ring-brand-purple/15" data-id="element-286" data-mp="2d4ccmmqh1ihb" />
            </div>
            <div className="flex-grow" data-id="element-287" data-mp="nov2ub4tandt">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-purpleDark" data-id="element-288" data-mp="r8ef9gqjjve6">
                TOMO I — ENCICLOPEDIA A-Z DE FLORA NATIVA ARGENTINA
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-289" data-mp="w92cik5d58gu">
                60 fichas técnicas · validación CONICET, ANMAT, INTA, Farmacopea
                Argentina
              </p>
              <p className="text-brand-text text-sm mb-4" data-id="element-290" data-mp="155kux2fyxdz6">
                La primera enciclopedia clínica de plantas medicinales
                argentinas creada para el terapeuta profesional. Desde Ambay
                hasta Zarzaparrilla, cada planta documentada con respaldo
                científico real.
              </p>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-purple/15 mb-4" data-id="element-291" data-mp="1ow6ba7dv4qk6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text" data-id="element-292" data-mp="1sy07a2d456e0">
                  {tomo1Features.map((f, i) => <div key={i} className="flex items-center" data-id="element-293" data-mp="1xu8mffrb8zl6" data-mpi={i}>
                      <span data-id="element-294" data-mp="3ig6v7wf4qrwb">{f}</span>
                    </div>)}
                </div>
              </div>
              <p className="text-brand-text text-sm mb-4" data-id="element-295" data-mp="3dhn65n58ozzq">
                Plantas como Carqueja, Lapacho, Peperina, Cedrón, Chañar, Yerba
                Mate, Llantén y Boldo Nativo — todas con respaldo científico.
              </p>
              <p className="font-serif italic text-brand-purple text-sm" data-id="element-296" data-mp="508vvkwf49lv">
                Dejá de buscar información dispersa en internet. Tenés todo lo
                que necesitás en un solo lugar, organizado y validado.
              </p>
            </div>
          </div>
        </div>

        {/* Tomo II */}
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-amber/20 border-brand-amber/40 backdrop-blur-sm shadow-sm" data-id="element-297" data-mp="3nei5g89c74f2">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-298" data-mp="op9lzcf16pet">
            <div className="shrink-0 mx-auto md:mx-0 w-24 md:w-28" data-id="element-299" data-mp="jvyklqszn0ua">
              <img src="https://cdn.magicpatterns.com/uploads/tPAEtcoLjEyywiU4vcFJAH/tomo2.png" alt="Tomo II — Preparaciones y Extracción" className="w-full aspect-[3/4] object-cover rounded-md shadow-lg ring-1 ring-brand-amber/15" data-id="element-300" data-mp="12ti8ue29a4lv" />
            </div>
            <div className="flex-grow" data-id="element-301" data-mp="y1qju7yr06xu">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-amber" data-id="element-302" data-mp="y0p8s3hqfkg4">
                TOMO II — TRATADO DE PREPARACIONES Y EXTRACCIÓN
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-303" data-mp="p2vcutnvqsth">
                60 páginas · manual técnico
              </p>
              <p className="text-brand-text text-sm mb-4" data-id="element-304" data-mp="b3vqxtrr4s10">
                El manual técnico que transforma tu conocimiento herbolario en
                preparaciones profesionales y seguras. Parámetros exactos para
                cada método de extracción.
              </p>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-amber/15 mb-4" data-id="element-305" data-mp="29gdrujrv7zbn">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text" data-id="element-306" data-mp="3u0j1053ho7oa">
                  {tomo2Features.map((f, i) => <div key={i} className="flex items-center" data-id="element-307" data-mp="7koked0pvsst" data-mpi={i}>
                      <span data-id="element-308" data-mp="7lzm87alqqha">{f}</span>
                    </div>)}
                </div>
              </div>
              <p className="font-serif italic text-brand-amber text-sm" data-id="element-309" data-mp="hi2mt8pt2h24">
                Porque no alcanza con saber qué planta usar — también tenés que
                saber cómo prepararla correctamente para que funcione.
              </p>
            </div>
          </div>
        </div>

        {/* Tomo III */}
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-greenMoss/20 border-brand-greenMoss/40 backdrop-blur-sm shadow-sm" data-id="element-310" data-mp="ljo6pe0rbvlt">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-311" data-mp="2savzryv48ez8">
            <div className="shrink-0 mx-auto md:mx-0 w-24 md:w-28" data-id="element-312" data-mp="2nccappl86n2n">
              <img src="https://cdn.magicpatterns.com/uploads/teUHX2imoWu5ynKtmXeYAf/tomo3.png" alt="Tomo III — Clínica y Seguridad" className="w-full aspect-[3/4] object-cover rounded-md shadow-lg ring-1 ring-brand-greenMoss/15" data-id="element-313" data-mp="2pq7p20m7qrwi" />
            </div>
            <div className="flex-grow" data-id="element-314" data-mp="33pz1vy0zu28x">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-greenMoss" data-id="element-315" data-mp="33oxp9p4bx7p3">
                TOMO III — CLÍNICA DE LA HERBORISTERÍA NATIVA
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-316" data-mp="2b2374yuzikes">
                60 páginas · El volumen más poderoso del kit
              </p>
              <p className="text-brand-text text-sm mb-4" data-id="element-317" data-mp="2fybg1uil9hdi">
                Protocolos terapéuticos listos para aplicar en tu consultorio
                desde el primer día. Criterio clínico puro: protocolos por
                sistema, dosificación adaptada por población y tabla maestra de
                interacciones medicamentosas.
              </p>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-greenMoss/15 mb-4" data-id="element-318" data-mp="1kpq2xgxiy2tj">
                <p className="text-xs font-bold uppercase tracking-wider text-brand-greenMoss mb-3" data-id="element-319" data-mp="1ft9c2eyxxacr">
                  Protocolos terapéuticos incluidos
                </p>
                <div className="space-y-2 mb-4" data-id="element-320" data-mp="15ua5d1xqjose">
                  {protocolos.map((p, i) => <div key={i} className="flex flex-col sm:flex-row sm:items-center text-xs md:text-sm border-b border-brand-greenMoss/10 pb-1 last:border-0 last:pb-0" data-id="element-321" data-mp="11sovzqketsmy" data-mpi={i}>
                      <span className="font-medium w-40 shrink-0 text-brand-text" data-id="element-322" data-mp="s2vgwfl26vdy">
                        {p.sys}
                      </span>
                      <span className="text-brand-text/80" data-id="element-323" data-mp="i3xxts6eju2c">{p.cond}</span>
                    </div>)}
                </div>
                <p className="text-xs md:text-sm text-brand-text mb-4 italic" data-id="element-324" data-mp="e3vttcd72ojw">
                  Cada protocolo incluye fórmula magistral lista para usar,
                  dosificación adulto/pediátrica/adulto mayor, duración del
                  tratamiento y criterios de derivación médica.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text" data-id="element-325" data-mp="3qnrjsptcnb8f">
                  {tomo3Features.map((f, i) => <div key={i} className="flex items-center" data-id="element-326" data-mp="n582gic7lpse" data-mpi={i}>
                      <span data-id="element-327" data-mp="r71w46nzltj2">{f}</span>
                    </div>)}
                </div>
              </div>
              <p className="font-serif italic text-brand-greenMoss text-sm" data-id="element-328" data-mp="dg6ikh2jmo95">
                Este tomo es la diferencia entre un terapeuta que "conoce
                plantas" y uno que trata pacientes con criterio clínico real.
              </p>
            </div>
          </div>
        </div>

        {/* Tomo IV */}
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-gold/15 border-brand-gold/50 backdrop-blur-sm shadow-sm" data-id="element-329" data-mp="1aw3wzn81uz3c">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-330" data-mp="1k81eh6hrm0ag">
            <div className="shrink-0 mx-auto md:mx-0 w-24 md:w-28" data-id="element-331" data-mp="1g7hiw7cub4qf">
              <img src="https://cdn.magicpatterns.com/uploads/fk7LMViRJYE2ymeDWJ1fM5/upsell.png" alt="Tomo IV — Alquimia Nativa" className="w-full aspect-[3/4] object-cover rounded-md shadow-lg ring-1 ring-brand-gold/30" data-id="element-332" data-mp="1u07449kjo5mh" />
            </div>
            <div className="flex-grow" data-id="element-333" data-mp="x9wvl4pq4e7x">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-goldDark" data-id="element-334" data-mp="xb7v2sc4yzt8">
                ⚗️ TOMO IV — ALQUIMIA NATIVA
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-335" data-mp="169jvfm2t1byv">
                Tratado de Espagiria Vegetal &amp; Fitococina Terapéutica Argentina · 50 páginas
              </p>
              <p className="text-brand-text text-sm mb-4" data-id="element-336" data-mp="2hpi8s250mk5w">
                El salto del herbolario al alquimista. Para el terapeuta que ya tiene la base y quiere llevar su práctica a un nivel que muy pocos conocen.
              </p>

              <div className="bg-white/80 p-4 rounded-lg border border-brand-gold/25 mb-4" data-id="element-337" data-mp="k2pg7r61gzy7">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text" data-id="element-338" data-mp="ozpp09u9wgt0">
                  {tomo4Features.map((feature, i) => <div key={i} className="flex items-center" data-id="element-339" data-mp="yr3jg37daqfa" data-mpi={i}>
                      <span data-id="element-340" data-mp="ysodlrprs7cm">{feature}</span>
                    </div>)}
                </div>
              </div>
              <p className="font-serif italic text-brand-goldDark text-sm" data-id="element-341" data-mp="17ri91erd6rol">
                Dominá preparaciones de alta gama con respaldo técnico y abrí una nueva dimensión en tu consultorio.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center mb-8 mt-12" data-id="element-342" data-mp="39kg3ff0shsbn">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-purpleDark" data-id="element-343" data-mp="3eh6l26s8svz6">
            🎁 3 BONUS ESTRATÉGICOS
          </h3>
          <p className="text-xs md:text-sm uppercase tracking-wider text-brand-goldDark mt-1 font-bold" data-id="element-344" data-mp="36zrvfoj9ujcm">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-345" data-mp="2x7m6knobgi1n">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          const numberLabel = String(i + 1).padStart(2, '0');
          return <div key={i} className="glass-panel rounded-2xl p-5 border-brand-purple/30 relative overflow-hidden bg-white/90 flex flex-col" data-id="element-346" data-mp="3pwjepxytcygo" data-mpi={i}>
                <div className={`absolute top-3 left-3 ${bonus.bgColor} border ${bonus.borderColor} ${bonus.color} text-[11px] md:text-sm font-mono font-bold px-2 py-0.5 rounded-md`} data-id="element-347" data-mp="3fxalj7brvnvd">
                  {numberLabel}
                </div>
                <div className="absolute top-0 right-0 bg-brand-gold text-brand-purpleDark text-xs md:text-sm font-bold px-3 py-1 rounded-bl-lg" data-id="element-348" data-mp="20hvawl4agou9">
                  GRATIS
                </div>

                <div className={`relative w-8 h-11 mt-6 mb-4 rounded-sm shadow-sm ${bonus.bgColor.replace('/10', '')} ring-1 ring-black/10 overflow-hidden`} aria-hidden="true" data-id="element-349" data-mp="w2epp8pyzhmf">
                  {/* Spine */}
                  <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-black/15" data-id="element-350" data-mp="n0f2tzs9xjbk" />
                  {/* Subtle horizontal line for cover detail */}
                  <div className="absolute top-1/2 left-1 right-0.5 h-px bg-white/30" data-id="element-351" data-mp="1euh40df52lti" />
                </div>

                <h4 className="text-base font-serif font-bold mb-2 leading-tight text-brand-text" data-id="element-352" data-mp="1aqhwulfr0zct">
                  {bonus.title}
                </h4>
                <p className={`${bonus.color} text-xs font-medium mb-3`} data-id="element-353" data-mp="3vhs2qe3k5lym">
                  {bonus.pages}
                </p>
                <p className="text-brand-text mb-3 text-xs flex-grow" data-id="element-354" data-mp="3qip4bci32dzm">
                  {bonus.desc}
                </p>
                <div className="text-xs font-medium text-brand-purple mb-2" data-id="element-355" data-mp="262hcc79h8n48">
                  {bonus.result}
                </div>
                <div className="text-xs text-brand-text/50 mt-auto" data-id="element-356" data-mp="2axmvwzfeppp5">
                  <span className="line-through" data-id="element-357" data-mp="2f01i9tiab7l6">{bonus.price}</span>
                  <span className="ml-2 font-bold text-brand-goldDark" data-id="element-358" data-mp="2jskqsc247cj4">
                    → GRATIS
                  </span>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-8" data-id="element-359" data-mp="2tpfq2x67pgyg">
          <div className="inline-block glass-panel px-6 py-3 rounded-full border-brand-purple/30 bg-white/80" data-id="element-360" data-mp="2tslfkdir6kup">
            <p className="text-sm md:text-base font-medium text-brand-text" data-id="element-361" data-mp="2ynqwsz17nbcg">
              Valor total bonos{' '}
              <span className="line-through text-brand-text/50" data-id="element-362" data-mp="14bu5d62rq5he">$37.000</span>{' '}
              <span className="text-brand-purple font-bold" data-id="element-363" data-mp="14dx0u5mowqti">
                → GRATIS con tu Kit Saberes Ancestrales Argentinos
              </span>
            </p>
          </div>
        </div>
      </div>

      <LaunchUrgency data-id="element-364" data-mp="26oyqu2dxtymk" />

      <Pricing data-id="element-365" data-mp="26pibvryvx34t" />

    </Section>;
};